import { Portfolio } from './Components/page/Portfolio';


function App() {
  return (
    <Portfolio/>
  )
}

export default App;
